import { RootState } from '../../../';

export const selectSearchValue = (state: RootState) => state.search.value;
export const selectResultCount = (state: RootState) => state.search.resultCount;
export const selectSelectedSearchScopes = (state: RootState) => state.search.selectedSearchScopes;
export const selectPagination = (state: RootState) => state.search.pagination;
export const selectLoading = (state: RootState) => state.search.loading;
